if (window.jQuery) {


    (function ($) {

        $('.promo-skew .promo-skew-wrapper-content, .promo-skew .promo-skew-wrapper-media').each(function (i) {

            //if ($(this).isInTheMiddle()) {
            if (isInTheMiddle($(this))) {
                $(this).css({
                    'transform': 'translateX(0)',
                    'opacity': 1
                });
            }
        });

        $(window).scroll(function (e) {

            $('.promo-skew .promo-skew-wrapper-content, .promo-skew .promo-skew-wrapper-media').each(function (i) {

                //if ($(this).isInTheMiddle()) {
                if (isInTheMiddle($(this))) {
                        $(this).css({
                        'transform': 'translateX(0)',
                        'opacity': 1
                    });
                }
            });
        });


    })(jQuery);

}